export const reportSalesStatisticsData = [
    {
        id: 1,
        title: "Active Deals",
        running_month_sales: "5,658",
        last_month_sales: "4,563",
        revenue: "23.65",
        icon:"feather-dollar-sign"
    },

    {
        id: 2,
        title: "Revenue Deals",
        running_month_sales: "76,852",
        last_month_sales: "85,748",
        revenue: "06.32",
        icon:"feather-pie-chart"
    },
    {
        id: 3,
        title: "Deals Created",
        running_month_sales: "2,354",
        last_month_sales: "1,578",
        revenue: "30.47",
        icon:"feather-plus-square"
    },
    {
        id: 4,
        title: "Deals Closing",
        running_month_sales: "40.847",
        last_month_sales: "52,468",
        revenue: "08.55",
        icon:"feather-sunset"
    },

]